export default __webpack_public_path__ + "static/media/IconDesc_EmptyCannister.64.8d7a6cb8.png";